// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"ceda5688","787":"2c1cee2b","907":"ad99e8b7"}[chunkId] + ".chunk.js";
};